
import { z } from "zod";

export const SocketSuggestedActionTypeValues = ["LIVE_CALL"] as const;
export const SocketSuggestedActionTypeSchema = /* @__PURE__ */ z.enum(SocketSuggestedActionTypeValues);
export const SocketSuggestedActionType: (typeof SocketSuggestedActionTypeSchema)["enum"] = { "LIVE_CALL": "LIVE_CALL" };
export type SocketSuggestedActionType = (typeof SocketSuggestedActionTypeValues)[number];
